<template>
  <div class="timezone-selector">
    <a-select
        v-model="currentTimezone"
        style="width: 140px"
        :bordered="false"
        @change="handleTimezoneChange"
        size="small"
    >
      <a-select-option
          v-for="option in timezoneOptions"
          :key="option.value"
          :value="option.value"
      >
        {{ option.label }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TimezoneSelector',
  computed: {
    ...mapGetters('timezone', [
      'timezoneOptions'
    ]),
    currentTimezone: {
      get () {
        return this.$store.getters['timezone/currentTimezone']
      },
      set (value) {
        this.updateTimezone(value)
      }
    }
  },
  methods: {
    ...mapActions('timezone', ['updateTimezone']),

    handleTimezoneChange (timezone) {
      if (timezone) {
        console.log('TimezoneSelector - 时区已更新:', timezone)
        // 可以在这里添加其他时区变更后的逻辑
        this.$message.success('时区设置已更新')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.timezone-selector {
  display: inline-block;

  :deep(.ant-select) {
    .ant-select-selector {
      border: none !important;
      background: transparent !important;
      box-shadow: none !important;

      &:hover {
        background: rgba(0, 0, 0, 0.04) !important;
      }
    }

    .ant-select-arrow {
      color: rgba(0, 0, 0, 0.45);
    }

    &.ant-select-focused {
      .ant-select-selector {
        border: none !important;
        box-shadow: none !important;
      }
    }
  }

  :deep(.ant-select-dropdown) {
    .ant-select-item {
      padding: 8px 12px;

      &:hover {
        background-color: #f5f5f5;
      }

      &.ant-select-item-option-selected {
        background-color: #e6f7ff;
        color: #1890ff;
      }
    }
  }
}
</style>
